export default __webpack_public_path__ + "static/media/zone_college.d22b823c.svg";